
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcInstrumentRadial as ObcInstrumentRadialElement} from '@oicl/openbridge-webcomponents/dist/building-blocks/instrument-radial/instrument-radial.js';
 
 
 

 
 export const ObcInstrumentRadial = createComponent({
   react: React,
   tagName: 'obc-instrument-radial',
   elementClass: ObcInstrumentRadialElement,
   events: {
     
   }
  });
 
 